// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"014828fb","513":"6a153b8a"}[chunkId] + ".chunk.js";
};